import React, { useEffect } from "react";
import Navbar from "./Navbar";
import PrivacyPolicyText from "./commonTextPages/PrivacyPolicyText.js";
import WrapperContainer from "./utilities/WrapperContainer.js";

export default function PrivacyPolicyHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <WrapperContainer
        maxwidth="70%"
        title="Privacy Policy"
        content={<PrivacyPolicyText />}
        loggedin={true}
      />
    </>
  );
}
